// extracted by mini-css-extract-plugin
export default {"modulesList":"UdvbW","item":"NsEqI","product":"P1psb"};